import { FormValues } from "./types";

export const names: Record<keyof FormValues, string> = {
  adjustmentType: "adjustmentType",
  amount: "amount",
  reason: "reason",
};
